export const detectBrowser = () => {
    let browserName = "unknown";

    // Opera 8.0+
    let isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    // Firefox 1.0+
    let isFirefox = typeof InstallTrigger !== 'undefined';

    // Safari 3.0+ "[object HTMLElementConstructor]" 
    let isSafari = false;
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
             // Chrome
        } else {
            isSafari = true // Safari
        }
    }

    // Internet Explorer 6-11
    let isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    let isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1 - 79
    let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    // Edge (based on chromium) detection
    let isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);


    if (isOpera)
        browserName = "Opera";

    if (isFirefox)
        browserName = "Firefox";

    if (isSafari)
        browserName = "Safari";

    if (isIE)
        browserName = "Internet Explorer"

    if (isEdge)
        browserName = "Edge";

    if (isChrome)
        browserName = "Chrome";

    if (isEdgeChromium)
        browserName = "Edge: Chromium";

    return browserName;
}